export enum ApplicationMimeTypesEnum {
    HTMLText = 0,
    MSExcel = 1,
    MSWord = 2,
    PDF = 3,
    Binary = 4,
    XMLText = 5,
    MSWord2007 = 6,
    MSExcel2007 = 7,
    GIF = 8,
    PNG = 9,
    JPEG = 10,
    TXT = 11,
    Bitmap = 12,
    DYN = 13,
    JSON = 14,
    SVG = 15
}
